const translations = {
    isMinimumPoints: 'Boundaries must have at least 3 points',
    overlapping: 'Boundaries cannot overlap',
    selfIntersecting: 'Invalid polygon. Fix the intersecting line or delete and start over'
};

export default translations;
